import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orderDetails = location.state?.orderDetails;

  useEffect(() => {
    if (!orderDetails) {
      navigate('/');
    }
  }, [orderDetails, navigate]);

  if (!orderDetails) return null;

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4 flex items-center justify-center">
      <div className="bg-white rounded-3xl shadow-xl max-w-2xl w-full mx-auto overflow-hidden">
        
        {/* Header Strip */}
        <div className="bg-green-600 py-10 text-center px-4">
          <div className="flex items-center justify-center mb-4">
            <span className="text-white text-5xl">✓</span>
          </div>
          <h1 className="text-white font-bold text-2xl mb-2">অর্ডার সফল হয়েছে!</h1>
          <p className="text-green-100 text-sm">আমরা শীঘ্রই কল করে অর্ডার কনফার্ম করবো</p>
        </div>

        {/* Card Body */}
        <div className="p-6 md:p-8">
          
          {/* Invoice Header */}
          <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-100">
            <span className="text-xl font-bold text-gray-800">অর্ডার ইনভয়েস</span>
            <span className="text-sm text-gray-500">
              {new Date(orderDetails.orderTime).toLocaleString('en-US', { timeZone: 'Asia/Dhaka' })}
            </span>
          </div>

          {/* Product Section */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 mb-4 text-center sm:text-left">
            <img 
              src={orderDetails.product.image} 
              alt={orderDetails.product.name} 
              className="w-20 h-20 rounded-xl object-cover shrink-0 border border-gray-100" 
            />
            <div className="flex-grow">
              <h3 className="font-bold text-gray-800 text-lg leading-snug">{orderDetails.product.name}</h3>
              <p className="text-green-600 text-sm font-medium mt-1">🎁 {orderDetails.product.freeItems}</p>
            </div>
            <div className="shrink-0 mt-2 sm:mt-0 text-center sm:text-right w-full sm:w-auto">
              <span className="font-bold text-green-600 text-xl">৳{orderDetails.product.price}</span>
            </div>
          </div>

          {/* Price Breakdown */}
          <div className="border-t border-gray-100 mt-4 pt-4 space-y-2">
            <div className="flex justify-between text-sm text-gray-600">
              <span>প্রোডাক্ট মূল্য</span>
              <span className="font-medium">৳{orderDetails.product.price}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>ডেলিভারি চার্জ</span>
              <span className="font-medium text-green-600">ফ্রি</span>
            </div>
            <div className="flex justify-between items-center text-lg font-bold border-t border-gray-200 pt-3 mt-2">
              <span className="text-gray-800">সর্বমোট</span>
              <span className="text-green-600 text-2xl">৳{orderDetails.product.price}</span>
            </div>
          </div>

          {/* Payment Method Badge */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mt-6">
            <p className="text-sm font-semibold text-yellow-800">
              💵 পেমেন্ট পদ্ধতি: পণ্য হাতে পেয়ে মূল্য পরিশোধ (Cash on Delivery)
            </p>
          </div>

          {/* Customer Info */}
          <div className="bg-gray-50 rounded-xl p-4 mt-4 border border-gray-100">
            <h4 className="font-semibold text-gray-700 mb-3 border-b border-gray-200 pb-2">ডেলিভারি তথ্য</h4>
            <div className="grid grid-cols-1 gap-2">
               <div className="flex">
                  <span className="text-xs text-gray-500 w-20 pt-1 shrink-0">নাম</span>
                  <span className="font-medium text-gray-800">{orderDetails.customer.name}</span>
               </div>
               <div className="flex">
                  <span className="text-xs text-gray-500 w-20 pt-1 shrink-0">ফোন</span>
                  <span className="font-medium text-gray-800">{orderDetails.customer.phone}</span>
               </div>
               {orderDetails.customer.address && (
                  <div className="flex">
                     <span className="text-xs text-gray-500 w-20 pt-1 shrink-0 block">ঠিকানা</span>
                     <span className="font-medium text-gray-800 block break-words w-full">{orderDetails.customer.address}</span>
                  </div>
               )}
            </div>
          </div>

        </div>

        {/* Bottom Buttons */}
        <div className="p-6 bg-gray-50 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <button 
            onClick={() => navigate('/')}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-xl transition-all shadow-sm order-2 sm:order-1 text-center"
          >
            🏠 হোম পেজে ফিরে যান
          </button>
          
          <a
            href="https://wa.me/8801814938247"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-[#25D366] hover:bg-[#1faB51] text-white font-bold py-3 px-6 rounded-xl transition-all shadow-sm flex items-center justify-center gap-2 order-1 sm:order-2"
          >
            💬 WhatsApp এ যোগাযোগ
          </a>
        </div>
        
      </div>
    </div>
  );
};

export default SuccessPage;
